export default __webpack_public_path__ + "static/media/Mastercard-logo.3a55b547.svg";